module.exports = __webpack_public_path__ + "img/minions.155feb82.png";